<template>
  <section class="caseList">
    <a class="box" :class="{'nojump':!url}" :href="!url?'javascript:void(0);':url+`?id=${item.id}`" v-for="(item) in dataList" :key="item.id">
      <section class="img transImg">
        <img v-lazy="item.realLogoUrl" :alt="item.customerName">
      </section>
      <a class="titleBox" :class="{'noclick':!url}" :href="url+`?id=${item.id}`"><strong class="ellipsis-2">{{item.customerName}}</strong></a>
    </a>
  </section>
</template>

<script>
export default {
  components: {},
  name: 'caseList',
  props: {
    dataList: {
      type: Array,
      default: () => ([])
    },
    url: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>

<style lang='scss' scoped>
strong {
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
}
.caseList {
  .box {
    float: left;
    margin-right: 23px;
    border: 1px solid #e2e2e2;
    box-sizing: border-box;
    width: 234px;
    height: 236px;
    margin-bottom: 46px;
    display: block;
    &:nth-child(2n) {
      margin-right: 22px;
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
    &:hover {
      img {
        transform: scale(1.2);
      }
    }
  }
  .img {
    padding: 30px 60px;
    padding-bottom: 29px;
    background: #fbfbfb;
    overflow: hidden;
    height: 169px;
    img {
      transition: all 0.3s;
    }
  }
  .titleBox {
    height: 65px;
    background: #fff;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      strong {
        color: #308dff;
      }
    }
  }
}
.noclick {
  pointer-events: none;
}

.nojump {
  cursor: default;
}
</style>
